import useAuthorizationStore from './UseAuthorizationStore';
var useAuthorizationConfig = function () { return useAuthorizationStore().config; };
export default useAuthorizationConfig;
//# sourceMappingURL=UseAuthorizationConfig.js.map